[
  {
    "id": "ae86",
    "displayName": "Hachi-86 GT",
    "drivetrain": "RWD",
    "colour": "White/black two-tone",
    "engineProfile": "inline4",
    "popUpHeadlights": true,
    "stats": {
      "power": 3,
      "weight": 9,
      "grip": 6,
      "driftEase": 9
    },
    "blurb": "Underpowered, nimble, forgiving. Carries speed through tight hairpins.",
    "physics": {
      "mass": 1250,
      "cogHeight": 0.5,
      "wheelbase": 2.47,
      "frontWeight": 0.52,
      "yawInertiaFactor": 0.22,
      "yawDamping": 0.6,
      "length": 4.5,
      "width": 1.7,
      "weightTransferGain": 1.4,
      "wheelRadius": 0.31,
      "drivetrain": "RWD",
      "awdFrontSplit": 0.35,
      "torqueCurve": [
        {
          "rpm": 1000,
          "torque": 170
        },
        {
          "rpm": 2000,
          "torque": 210
        },
        {
          "rpm": 3000,
          "torque": 250
        },
        {
          "rpm": 4000,
          "torque": 285
        },
        {
          "rpm": 5000,
          "torque": 310
        },
        {
          "rpm": 6000,
          "torque": 310
        },
        {
          "rpm": 7000,
          "torque": 275
        },
        {
          "rpm": 7500,
          "torque": 240
        }
      ],
      "idleRpm": 900,
      "redlineRpm": 7500,
      "launchRpm": 3500,
      "gearRatios": [3.32, 1.9, 1.31, 1.0, 0.82],
      "finalDrive": 4.08,
      "drivetrainEfficiency": 0.9,
      "upshiftRpm": 7000,
      "downshiftRpm": 3800,
      "shiftTicks": 6,
      "topSpeedKmh": 210,
      "dragCoeff": 0.5,
      "rollingResistance": 12,
      "brakeDecel": 11,
      "brakeBias": 0.65,
      "engineBraking": 2.5,
      "backwardDecel": 12,
      "gripFront": {
        "mu": 1.35,
        "peakSlipDeg": 7.5,
        "falloff": 0.85,
        "falloffSpan": 2.5
      },
      "gripRear": {
        "mu": 1.18,
        "peakSlipDeg": 8.5,
        "falloff": 0.76,
        "falloffSpan": 2.5
      },
      "handbrake": {
        "rearGrip": 0.35,
        "brakeDecel": 4,
        "attack": 0.5,
        "release": 0.25
      },
      "steering": {
        "lockDeg": 35,
        "highSpeedFactor": 0.2,
        "slideOpenDeg": 25,
        "speed": 3.5
      },
      "assists": {
        "counterSteer": 0.6,
        "counterSteerStartDeg": 6,
        "counterSteerRangeDeg": 18,
        "angleCapDeg": 46,
        "angleCapGain": 3,
        "throttleSlew": 5
      },
      "combinedSlip": 1.0,
      "reverse": {
        "accel": 4.5,
        "topSpeedKmh": 30,
        "engageSpeed": 0.4
      }
    }
  },
  {
    "id": "s13",
    "displayName": "Sunline S13",
    "drivetrain": "RWD",
    "colour": "Blue",
    "engineProfile": "inline4",
    "popUpHeadlights": false,
    "stats": {
      "power": 6,
      "weight": 6,
      "grip": 6,
      "driftEase": 8
    },
    "blurb": "The balanced all-rounder. Recommended first car.",
    "physics": {
      "mass": 1250,
      "cogHeight": 0.5,
      "wheelbase": 2.47,
      "frontWeight": 0.52,
      "yawInertiaFactor": 0.22,
      "yawDamping": 0.6,
      "length": 4.5,
      "width": 1.7,
      "weightTransferGain": 1.4,
      "wheelRadius": 0.31,
      "drivetrain": "RWD",
      "awdFrontSplit": 0.35,
      "torqueCurve": [
        {
          "rpm": 1000,
          "torque": 170
        },
        {
          "rpm": 2000,
          "torque": 210
        },
        {
          "rpm": 3000,
          "torque": 250
        },
        {
          "rpm": 4000,
          "torque": 285
        },
        {
          "rpm": 5000,
          "torque": 310
        },
        {
          "rpm": 6000,
          "torque": 310
        },
        {
          "rpm": 7000,
          "torque": 275
        },
        {
          "rpm": 7500,
          "torque": 240
        }
      ],
      "idleRpm": 900,
      "redlineRpm": 7500,
      "launchRpm": 3500,
      "gearRatios": [3.32, 1.9, 1.31, 1.0, 0.82],
      "finalDrive": 4.08,
      "drivetrainEfficiency": 0.9,
      "upshiftRpm": 7000,
      "downshiftRpm": 3800,
      "shiftTicks": 6,
      "topSpeedKmh": 210,
      "dragCoeff": 0.5,
      "rollingResistance": 12,
      "brakeDecel": 11,
      "brakeBias": 0.65,
      "engineBraking": 2.5,
      "backwardDecel": 12,
      "gripFront": {
        "mu": 1.35,
        "peakSlipDeg": 7.5,
        "falloff": 0.85,
        "falloffSpan": 2.5
      },
      "gripRear": {
        "mu": 1.18,
        "peakSlipDeg": 8.5,
        "falloff": 0.76,
        "falloffSpan": 2.5
      },
      "handbrake": {
        "rearGrip": 0.35,
        "brakeDecel": 4,
        "attack": 0.5,
        "release": 0.25
      },
      "steering": {
        "lockDeg": 35,
        "highSpeedFactor": 0.2,
        "slideOpenDeg": 25,
        "speed": 3.5
      },
      "assists": {
        "counterSteer": 0.6,
        "counterSteerStartDeg": 6,
        "counterSteerRangeDeg": 18,
        "angleCapDeg": 46,
        "angleCapGain": 3,
        "throttleSlew": 5
      },
      "combinedSlip": 1.0,
      "reverse": {
        "accel": 4.5,
        "topSpeedKmh": 30,
        "engageSpeed": 0.4
      }
    }
  },
  {
    "id": "fd3s",
    "displayName": "Rotary-7 FD",
    "drivetrain": "RWD",
    "colour": "Yellow",
    "engineProfile": "rotary",
    "popUpHeadlights": true,
    "stats": {
      "power": 8,
      "weight": 6,
      "grip": 7,
      "driftEase": 6
    },
    "blurb": "Rev-happy twin-rotor. Fast but punishes sloppy inputs.",
    "physics": {
      "mass": 1250,
      "cogHeight": 0.5,
      "wheelbase": 2.47,
      "frontWeight": 0.52,
      "yawInertiaFactor": 0.22,
      "yawDamping": 0.6,
      "length": 4.5,
      "width": 1.7,
      "weightTransferGain": 1.4,
      "wheelRadius": 0.31,
      "drivetrain": "RWD",
      "awdFrontSplit": 0.35,
      "torqueCurve": [
        {
          "rpm": 1000,
          "torque": 170
        },
        {
          "rpm": 2000,
          "torque": 210
        },
        {
          "rpm": 3000,
          "torque": 250
        },
        {
          "rpm": 4000,
          "torque": 285
        },
        {
          "rpm": 5000,
          "torque": 310
        },
        {
          "rpm": 6000,
          "torque": 310
        },
        {
          "rpm": 7000,
          "torque": 275
        },
        {
          "rpm": 7500,
          "torque": 240
        }
      ],
      "idleRpm": 900,
      "redlineRpm": 7500,
      "launchRpm": 3500,
      "gearRatios": [3.32, 1.9, 1.31, 1.0, 0.82],
      "finalDrive": 4.08,
      "drivetrainEfficiency": 0.9,
      "upshiftRpm": 7000,
      "downshiftRpm": 3800,
      "shiftTicks": 6,
      "topSpeedKmh": 210,
      "dragCoeff": 0.5,
      "rollingResistance": 12,
      "brakeDecel": 11,
      "brakeBias": 0.65,
      "engineBraking": 2.5,
      "backwardDecel": 12,
      "gripFront": {
        "mu": 1.35,
        "peakSlipDeg": 7.5,
        "falloff": 0.85,
        "falloffSpan": 2.5
      },
      "gripRear": {
        "mu": 1.18,
        "peakSlipDeg": 8.5,
        "falloff": 0.76,
        "falloffSpan": 2.5
      },
      "handbrake": {
        "rearGrip": 0.35,
        "brakeDecel": 4,
        "attack": 0.5,
        "release": 0.25
      },
      "steering": {
        "lockDeg": 35,
        "highSpeedFactor": 0.2,
        "slideOpenDeg": 25,
        "speed": 3.5
      },
      "assists": {
        "counterSteer": 0.6,
        "counterSteerStartDeg": 6,
        "counterSteerRangeDeg": 18,
        "angleCapDeg": 46,
        "angleCapGain": 3,
        "throttleSlew": 5
      },
      "combinedSlip": 1.0,
      "reverse": {
        "accel": 4.5,
        "topSpeedKmh": 30,
        "engageSpeed": 0.4
      }
    }
  },
  {
    "id": "r32",
    "displayName": "Raijin-32 R",
    "drivetrain": "AWD",
    "colour": "Black",
    "engineProfile": "straight6",
    "popUpHeadlights": false,
    "stats": {
      "power": 9,
      "weight": 3,
      "grip": 9,
      "driftEase": 3
    },
    "blurb": "Huge grip and traction. Hard to hold a slide, wins on fast sweepers.",
    "physics": {
      "mass": 1250,
      "cogHeight": 0.5,
      "wheelbase": 2.47,
      "frontWeight": 0.52,
      "yawInertiaFactor": 0.22,
      "yawDamping": 0.6,
      "length": 4.5,
      "width": 1.7,
      "weightTransferGain": 1.4,
      "wheelRadius": 0.31,
      "drivetrain": "RWD",
      "awdFrontSplit": 0.35,
      "torqueCurve": [
        {
          "rpm": 1000,
          "torque": 170
        },
        {
          "rpm": 2000,
          "torque": 210
        },
        {
          "rpm": 3000,
          "torque": 250
        },
        {
          "rpm": 4000,
          "torque": 285
        },
        {
          "rpm": 5000,
          "torque": 310
        },
        {
          "rpm": 6000,
          "torque": 310
        },
        {
          "rpm": 7000,
          "torque": 275
        },
        {
          "rpm": 7500,
          "torque": 240
        }
      ],
      "idleRpm": 900,
      "redlineRpm": 7500,
      "launchRpm": 3500,
      "gearRatios": [3.32, 1.9, 1.31, 1.0, 0.82],
      "finalDrive": 4.08,
      "drivetrainEfficiency": 0.9,
      "upshiftRpm": 7000,
      "downshiftRpm": 3800,
      "shiftTicks": 6,
      "topSpeedKmh": 210,
      "dragCoeff": 0.5,
      "rollingResistance": 12,
      "brakeDecel": 11,
      "brakeBias": 0.65,
      "engineBraking": 2.5,
      "backwardDecel": 12,
      "gripFront": {
        "mu": 1.35,
        "peakSlipDeg": 7.5,
        "falloff": 0.85,
        "falloffSpan": 2.5
      },
      "gripRear": {
        "mu": 1.18,
        "peakSlipDeg": 8.5,
        "falloff": 0.76,
        "falloffSpan": 2.5
      },
      "handbrake": {
        "rearGrip": 0.35,
        "brakeDecel": 4,
        "attack": 0.5,
        "release": 0.25
      },
      "steering": {
        "lockDeg": 35,
        "highSpeedFactor": 0.2,
        "slideOpenDeg": 25,
        "speed": 3.5
      },
      "assists": {
        "counterSteer": 0.6,
        "counterSteerStartDeg": 6,
        "counterSteerRangeDeg": 18,
        "angleCapDeg": 46,
        "angleCapGain": 3,
        "throttleSlew": 5
      },
      "combinedSlip": 1.0,
      "reverse": {
        "accel": 4.5,
        "topSpeedKmh": 30,
        "engageSpeed": 0.4
      }
    }
  },
  {
    "id": "s2000",
    "displayName": "Torque-2000 AP1",
    "drivetrain": "RWD",
    "colour": "Red",
    "engineProfile": "inline4-highrev",
    "popUpHeadlights": false,
    "stats": {
      "power": 6,
      "weight": 7,
      "grip": 8,
      "driftEase": 5
    },
    "blurb": "Screaming high-rev roadster with razor-sharp turn-in. The precision car.",
    "physics": {
      "mass": 1250,
      "cogHeight": 0.5,
      "wheelbase": 2.47,
      "frontWeight": 0.52,
      "yawInertiaFactor": 0.22,
      "yawDamping": 0.6,
      "length": 4.5,
      "width": 1.7,
      "weightTransferGain": 1.4,
      "wheelRadius": 0.31,
      "drivetrain": "RWD",
      "awdFrontSplit": 0.35,
      "torqueCurve": [
        {
          "rpm": 1000,
          "torque": 170
        },
        {
          "rpm": 2000,
          "torque": 210
        },
        {
          "rpm": 3000,
          "torque": 250
        },
        {
          "rpm": 4000,
          "torque": 285
        },
        {
          "rpm": 5000,
          "torque": 310
        },
        {
          "rpm": 6000,
          "torque": 310
        },
        {
          "rpm": 7000,
          "torque": 275
        },
        {
          "rpm": 7500,
          "torque": 240
        }
      ],
      "idleRpm": 900,
      "redlineRpm": 7500,
      "launchRpm": 3500,
      "gearRatios": [3.32, 1.9, 1.31, 1.0, 0.82],
      "finalDrive": 4.08,
      "drivetrainEfficiency": 0.9,
      "upshiftRpm": 7000,
      "downshiftRpm": 3800,
      "shiftTicks": 6,
      "topSpeedKmh": 210,
      "dragCoeff": 0.5,
      "rollingResistance": 12,
      "brakeDecel": 11,
      "brakeBias": 0.65,
      "engineBraking": 2.5,
      "backwardDecel": 12,
      "gripFront": {
        "mu": 1.35,
        "peakSlipDeg": 7.5,
        "falloff": 0.85,
        "falloffSpan": 2.5
      },
      "gripRear": {
        "mu": 1.18,
        "peakSlipDeg": 8.5,
        "falloff": 0.76,
        "falloffSpan": 2.5
      },
      "handbrake": {
        "rearGrip": 0.35,
        "brakeDecel": 4,
        "attack": 0.5,
        "release": 0.25
      },
      "steering": {
        "lockDeg": 35,
        "highSpeedFactor": 0.2,
        "slideOpenDeg": 25,
        "speed": 3.5
      },
      "assists": {
        "counterSteer": 0.6,
        "counterSteerStartDeg": 6,
        "counterSteerRangeDeg": 18,
        "angleCapDeg": 46,
        "angleCapGain": 3,
        "throttleSlew": 5
      },
      "combinedSlip": 1.0,
      "reverse": {
        "accel": 4.5,
        "topSpeedKmh": 30,
        "engageSpeed": 0.4
      }
    }
  }
]
